// Registers the service worker (scripts/service_worker.js) that lets the game run offline after a
// first visit. Only with the prod build, whose pages point to their version with <base id="build_version">:
// in dev, its cache would hide the changes. Next to the game pages, at the root of the site.

export default async function enableOfflinePlay () {
    try {
        if (!navigator.serviceWorker || !document.getElementById('build_version')) {
            return
        }
        await navigator.serviceWorker.register(new URL('service_worker.js', window.location.href))
    } catch (error) {
        console.warn('No offline play:', error.message) // sandboxed iframes (Kolibri…), private browsing
    }
}
